import ProfessionInfo from './ProfessionInfo.vue';

export default ProfessionInfo;



// WEBPACK FOOTER //
// ./src/pages/professions/card/info/index.ts